import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserInterface } from 'src/app/models/user.interface';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'globot-select-data-source',
  templateUrl: './select-data-source.component.html',
  styleUrls: ['./select-data-source.component.scss'],
})
export class SelectDataSourceComponent implements OnInit {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Output() subStepEvent = new EventEmitter<'' | 'upload' | 'web' | 'drive'>();
  @Input() showBackButton: boolean = true;

  user!: UserInterface;
  subscriptionsEnabled: boolean = environment.subscriptionsEnabled;
  /** Oculta la opción de Google Drive en la selección de fuente de datos */
  showGoogleDriveOption = false;

  constructor(private userService: UserService) {}
  ngOnInit(): void {
    this.userService.getUser().subscribe((user) => {
      this.user = user;
    });
  }

  next(): void {
    this.nextEvent.emit();
  }

  back(): void {
    this.backEvent.emit();
  }

  setSubStep(subStep: '' | 'upload' | 'web' | 'drive'): void {
    this.subStepEvent.emit(subStep);
  }
}
